import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";


@Component({
  selector: "app-job-detail-footer",
  imports: [CommonModule],
  templateUrl: "./job-detail-footer.component.html",
  styleUrl: "./job-detail-footer.component.scss",
  standalone: true
})
export class JobDetailFooterComponent {
  @Output() buttonClickCallBack = new EventEmitter<void>();
  @Input({ required: true }) buttonText!: string;
  @Input({ required: true }) completedItems!: number;
  @Input({ required: true }) totalItems!: number;


  getProgressPercent(): number {
    return (this.completedItems / this.totalItems) * 100;
  }

  buttonClick(): void {
    if (this.buttonClickCallBack) {
      this.buttonClickCallBack.emit();
    }
  }
}
